
<template>
  <div>
    <el-input suffix-icon="el-icon-search" v-model="formInline.keyword" placeholder="输入学员名称查询"
      style="width: 200px;margin: 10px 0;float: right;" clearable>
    </el-input>
    <el-table :data="userTable.rows" style="width: 100%" @select-all="selectAllUser" @select="selectUser"
      ref="multipleTable" row-key="id" @selection-change="selectChangeUser">
      <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="checkSelectable">
      </el-table-column>
      <el-table-column prop="stuid" label="学员ID">
      </el-table-column>
      <el-table-column prop="stuid" label="头像">
        <template slot-scope="scope">
          <el-avatar size="medium" :src="getTxurl(scope.row)"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="realName" label="姓名">
      </el-table-column>
      <el-table-column prop="sex" label="性别">
      </el-table-column>
      <!-- <el-table-column prop="age" label="年龄">
      </el-table-column> -->
      <el-table-column prop="loginName" label="电话">
      </el-table-column>
      <el-table-column v-if="flag=='1'&&activeObj.ontype.indexOf('ZXKT_producttype_2_6')=='-1'" prop="loginName" label="培训类型" width="250px" align="center">
        <template slot-scope="scope">
          <el-switch v-if="!isck||selectUserIds.indexOf(scope.row.id)>=0" v-model="scope.row.zgtype"
            @change="changeYx(scope.row.id,scope.row)" :disabled="selectUserIds.indexOf(scope.row.id) >=0"
            active-text="管理人员" active-value="2" active-color="#0071ba" inactive-text="主要负责人" inactive-value="1"
            inactive-color="#67c23a">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column v-if="flag=='1'&&activeObj.ontype.indexOf('ZXKT_producttype_2_6')=='-1'" prop="loginName" label="是否初次培训" width="250px" align="center">
        <template slot-scope="scope">
          <el-switch v-if="!isck||selectUserIds.indexOf(scope.row.id)>=0" v-model="scope.row.peixunitype"
            @change="changeYx(scope.row.id,scope.row)" :disabled="selectUserIds.indexOf(scope.row.id) >=0"
            active-text="再次教育" active-value="2" active-color="#0071ba" inactive-text="初次培训" inactive-value="1"
            inactive-color="#67c23a">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;width: 100%;height: 40px;">
      <el-pagination small layout="prev, pager, next" :total="userTable.total" style="float: right;"
        :hide-on-single-page="true" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="formInline.page">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaomingList',
    props: ['selectUserIds', 'wjSrc', 'appUsers', 'isck', 'flag', 'currentUser','activeObj'],
    data() {
      return {
        userTable: {
          rows: [],
          total: 0
        },
        dialogVisible: false,
        formInline: {
          rows: 10,
          page: 1,
          keyword: ''
        },
        selectIdArr: [],
        selectRows: [],
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        txadminUrl: require('@/assets/images/notxsex.png'),
      }
    },
    methods: {
      getUserList: function(flag) {
        var $this = this;
        if (!flag && this.userTable.rows.length > 0) {
          var data = this.userTable;
          if (appUsers.length > 0) {
            data.rows.map((item, i) => {
              if (this.selectUserIds.indexOf(item.id) >= 0) {
                appUsers.map((user) => {
                  if (user.appyuserid == item.id) {
                    user.id = user.appyuserid;
                    data.rows[i].zgtype = user.zgtype;
                    data.rows[i].peixunitype = user.peixunitype;
                  }
                })
              }
            })
          }
          this.userTable = data;
          return;
        };
        var appUsers = this.appUsers ? this.appUsers : [];
        var params = this.formInline;
        params.cid = this.currentUser.cid;
        this.$axios.get('/system/user_role/COM_USER_AQKT/list.htm?' + this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (appUsers.length > 0) {
            data.rows.map((item, i) => {
              if (this.selectUserIds.indexOf(item.id) >= 0) {
                appUsers.map((user) => {
                  if (user.appyuserid == item.id) {
                    user.id = user.appyuserid;
                    data.rows[i].zgtype = user.zgtype;
                    data.rows[i].peixunitype = user.peixunitype;
                  }
                })
              }
            })
          };
          this.userTable = data;
          this.openMonted();
        });
      },
      selectAllUser: function(selection, row) {
        var selectIdArr = this.selectIdArr;
        var selectRows = this.selectRows;
        selection.map((item) => {
          if (selectIdArr.indexOf(item.id) == -1) {
            selectIdArr.push(item.id);
            selectRows.push(item);
          }
        });
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
        this.$emit('changeBb', selectIdArr, selectRows)
      },
      selectUser: function(selection, row) {
        var selectIdArr = this.selectIdArr;
        var selectRows = this.selectRows;
        selection.map((item) => {
          if (selectIdArr.indexOf(item.id) == -1) {
            selectIdArr.push(item.id);
            selectRows.push(item);
          }
        })
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
        this.$emit('changeBb', selectIdArr, selectRows)
      },
      selectChangeUser: function(selection) {},
      openMonted: function() {
        if (this.selectUserIds.length > 0) {
          this.userTable.rows.forEach((row, i) => {
            var index = this.selectUserIds.indexOf(row.id);
            var sindex = this.selectIdArr.indexOf(row.id);
            if (index >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            } else if (sindex >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
              this.userTable.rows[i] = this.selectRows[sindex];
            } else {
              this.$refs.multipleTable.toggleRowSelection(row, false);
            }
          });
        } else if (this.selectIdArr.length > 0) {
          this.userTable.rows.forEach((row, i) => {
            var sindex = this.selectIdArr.indexOf(row.id);
            if (sindex >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
              this.userTable.rows[i] = this.selectRows[sindex];
            } else {
              this.$refs.multipleTable.toggleRowSelection(row, false);
            }
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleAave: function() {
        this.$emit('changeUser', this.selectIdArr, this.selectRows);
        this.dialogVisible = false
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else if (item.roleCode == "COM_ADMIN_AQKT") {
          return this.txadminUrl
        } else {
          return this.txnoUrl
        }
      },
      checkSelectable(row) {
        return this.selectUserIds.indexOf(row.id) == '-1';
      },
      changeYx: function(id, row) {
        var index = this.selectIdArr.indexOf(id);
        // 数据变化且已经被选中   需要修改选中的数据的状态值
        if (this.selectIdArr.indexOf(id) >= 0) {
          this.selectRows[index] = row;
          this.$emit('changeBb', this.selectIdArr, this.selectRows);
        }
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
    },
    created: function() {
      this.getUserList();
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList(1)
        },
        deep: true //true 深度监听
      },
      selectUserIds: {
        handler(val, oldVal) {
          this.openMonted()
        },
        deep: true //true 深度监听
      }
    },
  }
</script>

<style>
  .el-switch__label.el-switch__label--left.is-active {
    color: #67c23a;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BaomingList.vue